<template>
  <TokenExportsIndex v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import TokenExportsIndex from "./TokenExportsIndex.vue";

const initialData = ref<{
  processorOptions: any[];
  tokenExportPath: string;
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>

<style scoped></style>
